export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Name of the exercise group leader:",
				type: "medium",
			},
		],
	},
	{
		title: "Exercise group leader",
		type: "uni",
		id: 2,
		items: [
			{
				id: 2,
				text: "The support offered by the exercise group leader (e.g. during office hours) was sufficient.",
			},
			{
				id: 3,
				text: "The exercise group leader gave the opportunity to ask questions.",
			},
			{
				id: 4,
				text: "The exercise group leader was able to react competently to questions.",
			},
			{
				id: 5,
				text: "The exercise group leader was committed and motivated.",
			},
			{
				id: 6,
				text: "The exercise group leader was very competent.",
			},
		],
	},
	{
		title: "Exercise",
		type: "uni",
		id: 3,
		items: [
			{
				id: 7,
				text: "The exercise was helpful overall.",
			},
			{
				id: 8,
				text: "Working through the exercise tasks strengthened my understanding of the content.",
			},
			{
				id: 9,
				text: "I consider the framework conditions of the exercise in this form to be suitable (e.g. compulsory attendance, presence exercise, sample solution).",
			},
			{
				id: 10,
				text: "The correction of the solution is detailed and comprehensible.",
			},
			{
				id: 11,
				text: "The evaluation of the submitted solutions is fair and transparent.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 12,
				text: "I especially appreciated:",
			},
			{
				id: 13,
				text: "I did not like:",
			},
			{
				id: 14,
				text: "Suggestions for improvements:",
			},
		],
	},
];
